import { render, staticRenderFns } from "./changes.vue?vue&type=template&id=3ad76c78&scoped=true"
import script from "./changes.vue?vue&type=script&lang=js"
export * from "./changes.vue?vue&type=script&lang=js"
import style0 from "./changes.vue?vue&type=style&index=0&id=3ad76c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad76c78",
  null
  
)

export default component.exports